import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-testid": "placeholder-icon",
  viewBox: "0 0 24 24",
  role: "presentation"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.5 18.223v-3.556a.5.5 0 1 1 1 0v3.556c0 .705.572 1.277 1.277 1.277h3.556a.5.5 0 0 1 0 1H5.777A2.28 2.28 0 0 1 3.5 18.223m16 0v-3.556a.5.5 0 1 1 1 0v3.556a2.28 2.28 0 0 1-2.277 2.277h-3.556a.5.5 0 1 1 0-1h3.556c.705 0 1.277-.572 1.277-1.277m-16-8.89V5.777A2.28 2.28 0 0 1 5.777 3.5h3.556a.5.5 0 0 1 0 1H5.777c-.705 0-1.277.572-1.277 1.277v3.556a.5.5 0 0 1-1 0m16 0V5.777c0-.705-.572-1.277-1.277-1.277h-3.556a.5.5 0 1 1 0-1h3.556A2.28 2.28 0 0 1 20.5 5.777v3.556a.5.5 0 0 1-1 0"
    }, null, -1)
  ]))]))
}
export default { render: render }